(() => {
  'use strict';
  const text = window.ForgeText || {};
  const root = window.Shopify?.routes?.root || '/';
  const one = (selector, scope = document) => scope.querySelector(selector);
  const all = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const dialog = one('#ForgeCartDrawer');
  let cartBusy = false;
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency || window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  const element = (tag, className, value) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (value !== undefined) node.textContent = value;
    return node;
  };
  function showDialog(modal) {
    if (!modal || modal.open) return;
    modal.showModal();
    document.body.classList.add('has-dialog');
    all('[data-cart-open]').forEach(button => button.setAttribute('aria-expanded', String(modal === dialog)));
  }
  function wireDialog(modal) {
    if (!modal || modal.dataset.ready) return;
    modal.dataset.ready = 'true';
    modal.addEventListener('close', () => {
      if (!one('dialog[open]')) document.body.classList.remove('has-dialog');
      all('[data-cart-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
    });
    modal.addEventListener('click', event => {
      if (event.target !== modal) return;
      const rect = modal.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) modal.close();
    });
    all('[data-dialog-close],[data-cart-close]', modal).forEach(button => button.addEventListener('click', () => modal.close()));
  }
  async function request(path, options = {}) {
    const response = await fetch(root + path, { credentials: 'same-origin', headers: { Accept: 'application/json', ...(options.body ? { 'Content-Type': 'application/json' } : {}) }, ...options });
    let data;
    try { data = await response.json(); } catch { throw new Error(text.error); }
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : text.error);
    return data;
  }
  function renderCart(cart) {
    all('[data-cart-count]').forEach(node => { node.textContent = cart.item_count; });
    if (!dialog) return;
    one('[data-cart-total]', dialog).textContent = money(cart.total_price, cart.currency);
    one('[data-checkout]', dialog).disabled = cart.item_count === 0;
    const body = one('[data-cart-items]', dialog);
    body.replaceChildren();
    if (!cart.items.length) body.append(element('p', 'cart-empty', text.empty));
    cart.items.forEach(item => {
      const article = element('article', 'bag-item');
      if (item.image) {
        const image = element('img'); image.src = item.image; image.alt = item.product_title; image.width = 85; image.height = 112; article.append(image);
      } else article.append(element('span'));
      const info = element('div');
      const link = element('a', '', item.product_title); link.href = item.url; info.append(link);
      if (item.variant_title && item.variant_title !== 'Default Title') info.append(element('p', '', item.variant_title));
      info.append(element('b', '', money(item.final_line_price, cart.currency)));
      Object.entries(item.properties || {}).forEach(([key, value]) => {
        if (!key.startsWith('_') && value) info.append(element('small', '', key + ': ' + value));
      });
      (item.line_level_discount_allocations || []).forEach(discount => info.append(element('small', '', discount.discount_application.title)));
      const quantity = element('div', 'bag-quantity');
      [-1, 1].forEach((delta, index) => {
        if (index) quantity.append(element('span', '', item.quantity));
        const button = element('button', '', delta === -1 ? '−' : '+'); button.type = 'button'; button.dataset.cartKey = item.key; button.dataset.cartQuantity = item.quantity + delta;
        button.setAttribute('aria-label', delta === -1 ? text.decrease : text.increase); quantity.append(button);
      });
      info.append(quantity); article.append(info); body.append(article);
    });
  }
  async function refreshCart() { const cart = await request('cart.js'); renderCart(cart); return cart; }
  const cartError = message => { if (dialog) one('[data-cart-error]', dialog).textContent = message; };
  function setCartBusy(busy) {
    cartBusy = busy;
    if (!dialog) return;
    dialog.setAttribute('aria-busy', String(busy));
    all('[data-cart-key]', dialog).forEach(button => { button.disabled = busy; });
    const checkout = one('[data-checkout]', dialog);
    checkout.disabled = busy || !one('.bag-item', dialog);
  }
  document.addEventListener('click', async event => {
    if (event.target.closest('[data-cart-open]')) {
      if (!dialog) { location.assign(root + 'cart'); return; }
      showDialog(dialog); cartError('');
      if (cartBusy) return;
      try { setCartBusy(true); await refreshCart(); } catch (error) { cartError(error.message); } finally { setCartBusy(false); }
    }
    const quantity = event.target.closest('[data-cart-key]');
    if (quantity && !cartBusy) {
      cartError('');
      try { setCartBusy(true); renderCart(await request('cart/change.js', { method: 'POST', body: JSON.stringify({ id: quantity.dataset.cartKey, quantity: Number(quantity.dataset.cartQuantity) }) })); }
      catch (error) { cartError(error.message); }
      finally { setCartBusy(false); }
    }
    const reviewLink = event.target.closest('[data-review-open]');
    if (reviewLink) {
      const details = document.getElementById(reviewLink.hash.slice(1));
      if (details) details.open = true;
    }
    const sticky = event.target.closest('[data-sticky-add]');
    if (sticky) {
      const form = one('#ForgeProductForm');
      const submit = form && one('[data-add-to-cart]', form);
      if (submit && !submit.disabled) form.requestSubmit(submit);
      else one('#product-offers')?.scrollIntoView({ behavior: 'smooth' });
    }
  });
  function initialize(scope = document) {
    all('.customer-review-form .errors,.customer-review-form .form-success', scope).forEach(node => { const details = node.closest('details'); if (details) details.open = true; });
    all('dialog', scope).forEach(wireDialog);
    all('[data-motion]', scope).forEach(stage => {
      if (stage.dataset.ready) return; stage.dataset.ready = 'true';
      const button = one('[data-motion-toggle]', stage);
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      function pause(paused) {
        stage.classList.toggle('is-paused', paused);
        button.setAttribute('aria-pressed', String(paused)); button.setAttribute('aria-label', paused ? text.play : text.pause);
        one('[data-motion-label]', button).textContent = paused ? text.play : text.pause;
        one('.pause-icon', button).textContent = paused ? '▷' : 'Ⅱ';
      }
      pause(reduced.matches);
      reduced.addEventListener('change', event => { stage.classList.remove('motion-enabled'); pause(event.matches); });
      button.addEventListener('click', () => { stage.classList.add('motion-enabled'); pause(!stage.classList.contains('is-paused')); });
    });
    all('[data-gallery]', scope).forEach(gallery => {
      if (gallery.dataset.ready) return; gallery.dataset.ready = 'true';
      const buttons = all('[data-gallery-target]', gallery);
      buttons.forEach((button, index) => button.addEventListener('click', () => {
        buttons.forEach(other => { const selected = other === button; other.classList.toggle('is-active', selected); other.setAttribute('aria-pressed', String(selected)); });
        all('[data-gallery-panel]', gallery).forEach(panel => { panel.hidden = panel.dataset.galleryPanel !== button.dataset.galleryTarget; panel.classList.toggle('is-active', !panel.hidden); });
        one('[data-gallery-position]', gallery).textContent = String(index + 1).padStart(2, '0');
      }));
      one('[data-gallery-expand]', gallery).addEventListener('click', () => {
        const source = one('[data-gallery-panel]:not([hidden]) img', gallery);
        if (!source) return;
        const zoom = one('[data-zoom-image]', gallery); zoom.src = source.currentSrc || source.src; zoom.alt = source.alt;
        showDialog(one('[data-gallery-dialog]', gallery));
      });
    });
    all('[data-feature-tabs]', scope).forEach(tabs => {
      if (tabs.dataset.ready) return; tabs.dataset.ready = 'true';
      const buttons = all('[data-feature-target]', tabs);
      function activate(button) {
        buttons.forEach(other => { const selected = other === button; other.setAttribute('aria-selected', String(selected)); other.tabIndex = selected ? 0 : -1; other.classList.toggle('is-active', selected); });
        all('[data-feature-panel]', tabs).forEach(panel => { panel.hidden = panel.dataset.featurePanel !== button.dataset.featureTarget; });
      }
      buttons.forEach((button, index) => {
        button.tabIndex = index ? -1 : 0;
        button.addEventListener('click', () => activate(button));
        button.addEventListener('keydown', event => {
          let next;
          if (['ArrowRight', 'ArrowDown'].includes(event.key)) next = (index + 1) % buttons.length;
          if (['ArrowLeft', 'ArrowUp'].includes(event.key)) next = (index + buttons.length - 1) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          if (next !== undefined) { event.preventDefault(); activate(buttons[next]); buttons[next].focus(); }
        });
      });
    });
    all('[data-product-section]', scope).forEach(section => {
      if (section.dataset.ready) return; section.dataset.ready = 'true';
      const form = one('.product-form', section), button = one('[data-add-to-cart]', form), label = one('[data-add-label]', button), message = one('[data-form-message]', form);
      let submitting = false;
      function selectOffer(radio) {
        if (!radio || radio.disabled) return;
        all('.offer-choice', section).forEach(choice => choice.classList.toggle('is-selected', choice.contains(radio)));
        one('[data-selected-variant]', form).value = radio.dataset.variant;
        one('[data-selected-offer]', form).value = radio.dataset.title;
        one('[data-selected-pack]', form).value = radio.dataset.pack;
        one('[data-selected-price]', form).textContent = radio.dataset.price;
        all('[data-sticky-price]').forEach(node => { node.textContent = radio.dataset.price; });
        button.disabled = submitting || radio.dataset.available !== 'true';
        label.textContent = text.add;
        message.textContent = '';
      }
      all('[name="forge-offer"]', section).forEach(radio => radio.addEventListener('change', () => selectOffer(radio)));
      selectOffer(one('[name="forge-offer"]:checked', section));
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (submitting || button.disabled || cartBusy) return;
        submitting = true; button.disabled = true; label.textContent = text.adding; message.textContent = ''; cartError('');
        const payload = new FormData(form), properties = {};
        payload.forEach((value, key) => { const match = key.match(/^properties\[(.*)\]$/); if (match) properties[match[1]] = value; });
        let added = false;
        try {
          setCartBusy(true);
          await request('cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: Number(payload.get('id')), quantity: 1, properties }] }) });
          added = true;
          await refreshCart();
          showDialog(dialog);
        } catch (error) {
          if (added) { location.assign(root + 'cart'); return; }
          message.textContent = error.message;
        } finally {
          submitting = false; setCartBusy(false); label.textContent = text.add;
          button.disabled = !one('[name="forge-offer"]:checked:not(:disabled)', section);
        }
      });
      const sticky = one('[data-sticky-purchase]');
      if (sticky && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0; }, { threshold: 0 });
        observer.observe(section);
        section.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
      }
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
